import axios from "@/lib/axios";
import { useQuery } from "@tanstack/vue-query";

interface Props {
  immediate?: boolean;
  params?: Params;
}

interface Params {
  id: number | string;
}

const getChain = async (params: Params) => {
  const { data } = await axios.get(`/api/internal/chains/${params.id}`);

  return data;
};

const useChain = (props: Props) => {
  const { immediate = true } = props;

  const { data, isLoading, refetch } = useQuery(
    ["chain", props.params],
    () => getChain(props.params!),
    {
      enabled: immediate,
    },
  );

  return { data, isLoading, refetch };
};

export default useChain;
